"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shared_1 = require("../shared");
function getFieldQueryForPath(fragmentDefinitions, query, path) {
    if (!query || path.length === 0) {
        return query;
    }
    if (path.length < 2) {
        throw new Error(`Invalid path provided: [${path.join(", ")}]`);
    }
    return getFieldQueryForPath(fragmentDefinitions, (0, shared_1.getInlineFragment)(fragmentDefinitions, query[path[0]]).selection[path[1]]
        .fieldQuery, path.slice(2));
}
exports.default = getFieldQueryForPath;
//# sourceMappingURL=getFieldQueryForPath.js.map